import { render, staticRenderFns } from "./obmen.vue?vue&type=template&id=7fc6ea81&scoped=true&"
import script from "./obmen.vue?vue&type=script&lang=js&"
export * from "./obmen.vue?vue&type=script&lang=js&"
import style0 from "./obmen.vue?vue&type=style&index=0&id=7fc6ea81&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7fc6ea81",
  null
  
)

export default component.exports